import { render, staticRenderFns } from "./PreviewJobComments.vue?vue&type=template&id=bd7ed938"
import script from "./PreviewJobComments.vue?vue&type=script&lang=js"
export * from "./PreviewJobComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports